import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b91496b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "streaks-home-card__loading"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading streaks...", -1))
const _hoisted_3 = {
  key: 2,
  class: "streaks-home-card__list"
}
const _hoisted_4 = { class: "streaks-home-card__item-left" }
const _hoisted_5 = { class: "streaks-home-card__offensive" }
const _hoisted_6 = { class: "streaks-home-card__name" }

import { computed } from 'vue';

import StreakOffensive from '@/design-system/StreakOffensive.vue';
import DSCard from '@/design-system/DSCard.vue';
import DSEmptyState from '@/design-system/DSEmptyState.vue';
import DSButton from '@/design-system/DSButton.vue';

import { useStore } from '@/store';
import { FETCH_STREAKS } from '@/store/types/actions';


export default /*#__PURE__*/_defineComponent({
  __name: 'StreaksHomeCard',
  setup(__props) {

const store = useStore();
store.dispatch(FETCH_STREAKS);

const streaks = computed(() => store.state.streak.streaks);

const request_pending = computed(() => {
  const { streak: streak_request_pending = {} } = store.state.requests_pending;
  return streak_request_pending.fetch_all;
});

return (_ctx: any,_cache: any) => {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!

  return (_openBlock(), _createBlock(DSCard, {
    class: "streaks-home-card",
    title: "Habits in Progress",
    shadow: "md"
  }, {
    content: _withCtx(() => [
      (request_pending.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_q_spinner_gears, {
              color: "primary",
              size: "2rem"
            }),
            _hoisted_2
          ]))
        : (! streaks.value.length)
          ? (_openBlock(), _createBlock(DSEmptyState, {
              key: 1,
              title: "No Streaks Found",
              message: "Start tracking your habits to build consistency!",
              icon: "whatshot"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(streaks.value, (streak) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: streak.id,
                  class: "streaks-home-card__item"
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(StreakOffensive, {
                        offensive: streak.offensive
                      }, null, 8, ["offensive"])
                    ]),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(streak.name), 1)
                  ]),
                  _createVNode(DSButton, {
                    icon: "visibility",
                    variant: "outline",
                    size: "sm",
                    onClick: ($event: any) => (_ctx.$router.push(`/streaks/${streak.id}`)),
                    "aria-label": "View streak"
                  }, null, 8, ["onClick"])
                ]))
              }), 128))
            ]))
    ]),
    _: 1
  }))
}
}

})